import { render } from "./AssignmentView.vue?vue&type=template&id=250bc142&scoped=true&ts=true"
import script from "./AssignmentView.vue?vue&type=script&lang=ts"
export * from "./AssignmentView.vue?vue&type=script&lang=ts"

import "./AssignmentView.vue?vue&type=style&index=0&id=250bc142&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250bc142"]])

export default __exports__